<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="policies"
        >
          <span class="fs-3">
            {{ 'saleModule.policies' | translate }}
          </span>

          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsed" class="card-body" id="policies">
      <ng-container
        *ngFor="let policy of getPolicies(form); let i = index"
        formArrayName="policies"
      >
        <div [formGroupName]="i">
          <div class="mb-4">
            <label class="form-label">{{
              'productModule.cancellationProduct' | translate
            }}</label>

            <product-select-input
              [products]="products$ | async"
              formControlName="cancelationProductId"
              [allowClearing]="true"
              style="width: 100%"
            ></product-select-input>
          </div>

          <fieldset class="mb-3">
            <legend class="form-label" id="calcelDesc{{ i }}">{{
              'general.description' | translate
            }}</legend>
            <div class="row gx-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group mb-3">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      id="flag-nl-cl{{ i }}"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    attr.aria-labelledby="calcelDesc{{ i }} flag-nl-cl{{ i }}"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      id="flag-en-cl{{ i }}"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    attr.aria-labelledby="calcelDesc{{ i }} flag-en-cl{{ i }}"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group mb-3">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-cl{{ i }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    attr.aria-labelledby="calcelDesc{{ i }} flag-fr-cl{{ i }}"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-cl{{ i }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    attr.aria-labelledby="calcelDesc{{ i }} flag-de-cl{{ i }}"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </fieldset>

          <div class="card-table">
            <table class="table border-bottom table-light table-sm">
              <thead>
                <tr>
                  <th scope="col">
                    {{ 'saleModule.payablePercentage' | translate }}
                  </th>
                  <th scope="col">
                    {{ 'productGroupModule.productGroups' | translate }}
                  </th>
                  <th scope="col"
                    ><span class="visually-hidden">{{
                      'general.actions' | translate
                    }}</span></th
                  >
                </tr>
              </thead>
              <tbody formArrayName="values">
                <tr
                  [formGroupName]="j"
                  *ngFor="let value of getValues(policy); let j = index"
                >
                  <td>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="payablePercentage"
                    />
                  </td>
                  <td>
                    <ng-select
                      *ngIf="productGroups$ | async"
                      class="d-block"
                      [items]="productGroups$ | async"
                      [multiple]="true"
                      [closeOnSelect]="false"
                      [searchable]="true"
                      formControlName="productGroupIds"
                      bindLabel="description"
                      bindValue="id"
                      placeholder="{{ 'general.select' | translate }}"
                      [clearSearchOnAdd]="true"
                    >
                    </ng-select>
                  </td>
                  <td>
                    <button
                      class="btn btn-ghost-secondary"
                      type="button"
                      (click)="deleteValuesRow(policy, j)"
                      [canSee]="[accessRights.ConfigurationOptions_delete]"
                    >
                      <i
                        role="img"
                        class="fa fa-trash-alt"
                        attr.aria-label="{{ 'general.delete' | translate }}"
                      ></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-between pb-3">
            <button
              class="btn btn-soft-primary btn-sm"
              type="button"
              (click)="addValuesRow(policy)"
              [canSee]="[accessRights.Settings_write]"
              [canSee]="[accessRights.ConfigurationOptions_write]"
            >
              {{ 'general.addGroup' | translate }}
            </button>

            <button
              class="btn btn-soft-secondary"
              type="button"
              (click)="deletePolicyRow(i)"
              [canSee]="[accessRights.ConfigurationOptions_delete]"
            >
              {{ 'general.removePolicy' | translate }}
            </button>
          </div>
        </div>
        <hr class="card-table" />
      </ng-container>

      <div class="form-footer justify-content-between sticky-bottom">
        <button
          class="btn btn-primary"
          type="button"
          (click)="addPolicyRow(null, true)"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.addPolicy' | translate }}
        </button>
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
